import { render, staticRenderFns } from "./DeviceDetector.vue?vue&type=template&id=36f5e120&scoped=true"
import script from "./DeviceDetector.vue?vue&type=script&lang=js"
export * from "./DeviceDetector.vue?vue&type=script&lang=js"
import style0 from "./DeviceDetector.vue?vue&type=style&index=0&id=36f5e120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f5e120",
  null
  
)

export default component.exports